import utils from '@/utils'
import _ from 'lodash'

const LIST_PARAMS_KEY = 'invoice:listParams'

export const invoice = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
    students: [],
    studentsLoading: false,
    subscriptionOrders: [],
    subscriptionOrdersLoading: false,
    teachers: [],
    teachersLoading: false,
    deposit: [],
    depositLoading: false,
    paymentMethods: [],
    paymentMethodsLoading: false,
    itemCategories: [],
    itemCategoriesLoading: false,
    addItemCategoryLoading: false,
    updateBulkLoading: false,
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    listParams: (state) => {
      return state.listParams
    },
    students: (state) => {
      return state.students
    },
    isStudentsLoading: (state) => {
      return state.studentsLoading
    },
    subscriptionOrders: (state) => {
      return state.subscriptionOrders
    },
    isSubscriptionOrdersLoading: (state) => {
      return state.subscriptionOrdersLoading
    },
    teachers: (state) => {
      return state.teachers
    },
    isTeachersLoading: (state) => {
      return state.teachersLoading
    },
    deposit: (state) => {
      return state.deposit
    },
    isDepositLoading: (state) => {
      return state.depositLoading
    },
    paymentMethods: (state) => {
      return state.paymentMethods
    },
    isPaymentMethodsLoading: (state) => {
      return state.paymentMethodsLoading
    },
    itemCategories: (state) => {
      return state.itemCategories
    },
    isItemCategoriesLoading: (state) => {
      return state.itemCategoriesLoading
    },
    isAddItemCategoryLoading: (state) => {
      return state.addItemCategoryLoading
    },
    isUpdateBulkLoading: (state) => {
      return state.updateBulkLoading
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
    setListParamOptions(state, data) {
      let result = state.listParams
      if (!result || !result.options) {
        result = {
          options: {},
        }
      }
      _.merge(result.options, data)
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(result))
    },
    setStudents(state, data) {
      state.students = data
    },
    setStudentsLoading(state, data) {
      state.studentsLoading = data
    },
    setSubscriptionOrders(state, data) {
      state.subscriptionOrders = data
    },
    setSubscriptionOrdersLoading(state, data) {
      state.subscriptionOrdersLoading = data
    },
    setTeachers(state, data) {
      state.teachers = data
    },
    setTeachersLoading(state, data) {
      state.teachersLoading = data
    },
    setDeposit(state, data) {
      state.deposit = data
    },
    setDepositLoading(state, data) {
      state.depositLoading = data
    },
    setPaymentMethods(state, data) {
      state.paymentMethods = data
    },
    setPaymentMethodsLoading(state, data) {
      state.paymentMethodsLoading = data
    },
    setItemCategories(state, data) {
      state.itemCategories = data
    },
    setItemCategoriesLoading(state, data) {
      state.itemCategoriesLoading = data
    },
    setAddItemCategoryLoading(state, data) {
      state.addItemCategoryLoading = data
    },
    addItemCategory(state, data) {
      state.itemCategories.push(data)
    },
    setUpdateBulkLoading(state, data) {
      state.updateBulkLoading = data
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/invoices`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/invoices/${id}`)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/invoices', data)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(`/api/invoices/${data.id}`, data)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/invoices/${id}`)
      commit('setDeleteLoading', false)
    },
    async getStudents({ commit, dispatch }, { search, filters }) {
      commit('setStudentsLoading', true)
      try {
        const response = await axios.get(`/api/students`, {
          params: {
            name: search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setStudents', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/students', error },
          { root: true }
        )
      } finally {
        commit('setStudentsLoading', false)
      }
    },
    async getSubscriptionOrders({ commit, dispatch }, { search, filters }) {
      commit('setSubscriptionOrdersLoading', true)
      try {
        const response = await axios.get(`/api/subscription-orders`, {
          params: {
            search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setSubscriptionOrders', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/subscriptionOrders', error },
          { root: true }
        )
      } finally {
        commit('setSubscriptionOrdersLoading', false)
      }
    },
    async getDepositBySubscriptionOrderAndTerm(
      { commit, dispatch },
      { filters }
    ) {
      commit('setDepositLoading', true)
      try {
        const response = await axios.get(
          `/api/subscription-orders/view-deposit/${filters.id}/${filters.term}`
        )
        commit('setDeposit', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/deposit', error },
          { root: true }
        )
      } finally {
        commit('setDepositLoading', false)
      }
    },
    async getTeachers({ commit, dispatch }, { search, filters }) {
      commit('setTeachersLoading', true)
      try {
        const response = await axios.get(`/api/teachers`, {
          params: {
            name: search,
            ...filters,
          },
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setTeachers', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/teachers', error },
          { root: true }
        )
      } finally {
        commit('setTeachersLoading', false)
      }
    },
    async getPaymentMethods({ commit, dispatch }) {
      commit('setPaymentMethodsLoading', true)
      try {
        const response = await axios.get(`/api/invoice-payment-methods`)
        commit('setPaymentMethods', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/paymentMethods', error },
          { root: true }
        )
      } finally {
        commit('setPaymentMethodsLoading', false)
      }
    },
    async getItemCategories({ commit, dispatch }) {
      commit('setItemCategoriesLoading', true)
      try {
        const response = await axios.get(`/api/invoice-item-categories`)
        commit('setItemCategories', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/itemCategories', error },
          { root: true }
        )
      } finally {
        commit('setItemCategoriesLoading', false)
      }
    },
    async addItemCategory({ commit, dispatch }, data) {
      commit('setAddItemCategoryLoading', true)
      try {
        const response = await axios.post(`/api/invoice-item-categories`, data)
        commit('addItemCategory', response.data.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/addItemCategory', error },
          { root: true }
        )
      } finally {
        commit('setAddItemCategoryLoading', false)
      }
    },
    async updateBulk({ commit, dispatch }, request) {
      commit('setUpdateBulkLoading', true)
      try {
        await axios.post(`/api/invoices/update-bulk`, request)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'invoice/updateBulk', error },
          { root: true }
        )
      } finally {
        commit('setUpdateBulkLoading', false)
      }
    },
  },
}
